<template>
    <div class="widgetContainer">
        <div class="d-flex flex-column">
          <span class="widgetTitle">{{ $t("Webportal.Actions.SurveyRevisions") }} <span class="fw-bold"> (N = {{ widgetdata.TotalCount }})</span></span>
          <div v-if="widgetdata && widgetdata.Statuses" class="overflow-auto">
            <table>
              <tbody>
                <tr v-for="status in widgetdata.Statuses" :key="status.StatusId">
                  <td>{{ getRevisionStatusText(status.StatusId) }}</td>
                  <td class="ps-1 fw-bold text-end">{{ status.Count }}</td>
                  <td class="ps-2"><b-progress :value="status.Result" :max="100" /></td>
                  <td class="font-weight-light text-end">{{ $n(status.Result, { minimumFractionDigits: percentageNumberOfDecimalPoints, maximumFractionDigits: percentageNumberOfDecimalPoints}) }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="align-self-end">
            <button class="closeButton" v-on:click="$emit('close-widget')">
                <font-awesome-icon class="closeButtonIcon" icon="window-close" size="xs"/>
            </button>
        </div>
    </div>
</template>
<script>
  import SurveyRevisionMixin from "@/mixins/SurveyRevisionMixin";

  export default {
    name: "WidgetCheckRevisions",

    mixins: [SurveyRevisionMixin],

    props: {
      widgetdata: { type: Object, default: null },
      percentageNumberOfDecimalPoints: { type: Number, default: 2 }
    }
  }
</script>
<style lang="scss" scoped>
  table {
    border: 0;
    font-size: 12px;

    .progress {
      width: 80px;
      height: 6px;
    }
  }
</style>
